import api from "../../api/api";

//~-------------------Get all the users when searched---------------------------------------
export const getDataPasscodeStatusWise = async (data) =>
  await api.get(`getPscdRqstedUsers/${data}`);

//^-------------------Get preferred Managers to assign-------------------------------------
export const getPreferredManagersList = async (data) =>
  await api.get(`getAllMgrsWidActivePscd/${data.managerType}`);

//&------------------When we accept the requested passcode-----------------------------
export const changeRequestedPasscodeStatus = async (data) => {
  try {
    const response = await api.post(`allocatePscdRqstedUser`, data);
    return response;
  } catch (error) {
    console.error("Error while changing requested passcode status:", error);
    throw error;
  }
};

//!--------------When a passcode record is deleted-------------------------------------
export const rejectPasscodeStatus = async (data) => {
  try {
    const response = await api.delete(`rejectPscdRqstedUser`, { data: data });
    return response;
  } catch (error) {
    console.error("Error while changing requested passcode status:", error);
    throw error;
  }
};
